import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { useNavigate } from 'react-router-dom';
import leftarrow from '../../../safreeimg/left-arrow.png';

const GuardianGroupView = () => {
    const [organisations, setOrganisations] = useState([]);
    const [groupName, setGroupName] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);

    const rowsPerPage = 10;
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrganisations = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    setError('No authentication token found');
                    setLoading(false);
                    return;
                }

                const hash = window.location.hash.substring(1);
                if (!hash) {
                    setError('No ID found in the URL hash');
                    setLoading(false);
                    return;
                }

                console.log('Extracted ID:', hash);
                console.log('Token:', token);

                const response = await axios.get(
                    `https://api.safree.org/api-v2022/org-guardian/my/v1/group-details/${hash}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                console.log('API Response:', response);

                if (response.data && Array.isArray(response.data.data)) {
                    setOrganisations(response.data.data);
                    if (response.data.data[0]?.groupName) {
                        setGroupName(response.data.data[0].groupName);
                    }
                } else {
                    setError('Invalid data format from API');
                }
            } catch (err) {
                console.error('Error fetching organisations:', err);
                setError('An error occurred while fetching organisations: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOrganisations();
    }, []);

    const totalPages = Math.ceil(organisations.length / rowsPerPage);
    const currentRows = organisations.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (direction) => {
        if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    if (loading) return <div className="loading"><img src={Loader} alt="Loading" /></div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="container user-management">
            {/* Header Section */}
            <div className="row header">
                <div className="col-md-6">
                    {/* Display groupName */}
                    <p className="sub-heading">
                    <img onClick={handleBackClick} className="back-button" src={leftarrow} alt="" /> <strong>{groupName}</strong> Details
                    </p>
                </div>
            </div>
            <div className="content-wrapper">
                {/* Table Section */}
                <div className="table-container">
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>User Name</th>
                                <th>Email</th>
                                <th>Phone No</th>
                                <th>Identity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentRows.map((organisation, index) => (
                                <tr key={organisation._id || index}>
                                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                                    <td>{organisation.name}</td>
                                    <td>{organisation.email}</td>
                                    <td>{organisation.phoneNumber}</td>
                                    <td>
                                        {organisation.loginUser === "1" && (
                                            <span className='Identitydote'>•</span> // Green dot
                                        )}
                                        {organisation.identity}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Pagination Section */}
                    <div className="pagination-container">
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('prev')}
                            disabled={currentPage === 1}
                        >
                            &laquo; Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, index) => (
                            <button
                                key={index}
                                className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button
                            className="pagination-btn"
                            onClick={() => handlePageChange('next')}
                            disabled={currentPage === totalPages}
                        >
                            Next &raquo;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuardianGroupView;
